import {
  required,
  confirmed,
  length,
  email,
  regex,
  ext,
} from "vee-validate/dist/rules";
import { extend, validate } from "vee-validate";
import * as vee from "./helpers/veeValidation";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("email", {
  ...email,
  message: "This field must be a valid email",
});

extend("confirmed", {
  ...confirmed,
  message: "This field confirmation does not match",
});

extend("length", {
  ...length,
  message: "This field must have 2 options",
});

extend("regex", {
  ...regex,
  message: "Password must have at least one capital letter and number ",
});

extend("ext", {
  ...ext,
  message: "The file format isnt supported ",
});

extend("companyName", {
  async validate(value, args) {
    let { company } = await vee.checkCompanyFieldExist("company_name", value);
    return company.length < 1;
  },

  message: "This company name already exists",
});

extend("companyEmail", {
  async validate(value, args) {
    let { company } = await vee.checkCompanyFieldExist("email", value);
    return company.length < 1;
  },

  message: "This company email already exists",
});

extend("MenuName", {
  async validate(value, args) {
    let menu = await vee.checkMenuFieldExist("menu_name", value);
    return menu.length < 1;
  },

  message: "This menu name already exists",
});

extend("CategoryName", {
  async validate(value, ) {
    let menu1 = await vee.checkCategoryFieldExists("name", value);
    let menu2 = await vee.checkCategoryFieldExists("title", value);
 const    menu=[...menu1,...menu2]
    return menu.length<1;
  },

  params: ["menuId"],
  message: "This category name already exists",
});

extend("ItemName", {
  async validate(value, { menuId }) {
    let items = await vee.checkItemFieldExists("name", value, menuId);
    return items.length < 1;
  },
  params: ["menuId"],
  message: "This item name already exists",
});
